/* eslint-disable react/require-default-props */
import React, { Dispatch, SetStateAction } from 'react'
import { MapTile } from '@dataplace.ai/ui-components/atoms'
import { MapVisualizationModal } from '@dataplace.ai/ui-components/molecules'
import {
  BasicLayers, FeatureCollectionLayers, GeojsonLayers, WMSLayers,
} from '@dataplace.ai/ui-components/atoms/MapTile/@types/LayersTypes'
import { useTranslation } from 'react-i18next'
import { mapConst } from 'apps/placeme/src/features/Analyse/utils/constants'
import { IAnalysedLocation } from 'apps/placeme/src/features/ChooseLocationReport/@types/IChooseLocationSlice'
import { MapWrapper } from '../WellFitCompetitionWithinRange.styles'

interface IMapLocation {
  zoom: number
  center: {
    lat: number
    lng: number
  }
}

interface WellFitCompetitionMapProps {
  layers: (BasicLayers | GeojsonLayers | WMSLayers | FeatureCollectionLayers)[]
  analysedLocation?: IAnalysedLocation
  isMapModalDisplayed: boolean
  mapLocation: IMapLocation
  setIsMapModalDisplayed: Dispatch<SetStateAction<boolean>>
  catchmentId?: string
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function WellFitCompetitionMap({
  layers,
  analysedLocation,
  isMapModalDisplayed,
  setIsMapModalDisplayed,
  catchmentId,
  mapLocation,
}: WellFitCompetitionMapProps) {
  const { t } = useTranslation()

  return (
    <>
      <MapWrapper>
        <MapTile
          dragging
          height='100%'
          layers={layers}
          location={analysedLocation}
          mapId='example-map-data-tile'
          pinDisplayed
          popupHeading={`${t('generic.chosen_location')}:`}
          popupParagraph={analysedLocation?.address}
          showScaleControl
          width='100%'
          zoom={mapConst.zoom[13]}
          zoomControl
        />
      </MapWrapper>
      {isMapModalDisplayed && (
        <MapVisualizationModal
          isDisplayed={isMapModalDisplayed}
          layers={layers}
          location={analysedLocation}
          mapId={`wellfit-map-${catchmentId}`}
          setIsDisplay={setIsMapModalDisplayed}
          zoom={mapLocation.zoom}
        />
      )}
    </>
  )
}

export default WellFitCompetitionMap
